import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import {
  CurrentDates,
  InitialDates,
} from '../_components/molecules/NewEditDuration';
import { EmployerGroups } from '../core-utils/helper-utils/reportsWorkFlowHelper';
import { ICohortDetails } from '../_components/organisms/CreateNewModalCoreComponent';

export class CustomQueriesStore {
  id: string = '';
  name: string = '';
  type: string = '';
  features: string[] = [];
  memberIds: string[] = [];
  claimIds: string[] = [];
  employerGroups: EmployerGroups[] = [];
  planPeriod: InitialDates = {
    start_month: '',
    end_month: '',
    plan_start_month: '',
    start_year: 0,
    end_year: 0,
    plan_end_month: '',
    recent_plan_year: 0
  };
  currentDates: CurrentDates = {
    startDate: '',
    endDate: '',
  };
  downloadfrequency: string = '';
  cohortDetailsList: ICohortDetails[] = [];
  createdBy: string = '';
  typesAndFeatures: any = {};
  isIndividualGroup: boolean = true;

  constructor() {
    makeObservable(this, {
      id: observable,
      name: observable,
      type: observable,
      features: observable,
      memberIds: observable,
      claimIds: observable,
      employerGroups: observable,
      planPeriod: observable,
      currentDates: observable,
      downloadfrequency: observable,
      cohortDetailsList: observable,
      createdBy: observable,
      setCustomQueriesData: action,
      removeCustomQueriesData: action,
      isIndividualGroup: observable,
      setCurrentDates: action,
    });

    makePersistable(this, {
      name: 'CustomQueriesStore',
      properties: [
        'id',
        'name',
        'type',
        'features',
        'memberIds',
        'claimIds',
        'employerGroups',
        'planPeriod',
        'currentDates',
        'downloadfrequency',
        'cohortDetailsList',
        'createdBy',
        'typesAndFeatures',
        'isIndividualGroup',
      ],
      storage: window.localStorage,
    });
  }

  setTypesAndFeatues(typesAndFeatures: any) {
    this.typesAndFeatures = typesAndFeatures;
  }

  removeTypesAndFeatures() {
    this.typesAndFeatures = {};
  }

  setEmployerGroups(employerGroups: EmployerGroups[]) {
    this.employerGroups = employerGroups;
  }

  setCustomQueriesData(
    id: string,
    name: string,
    type: string,
    features: string[],
    memberIds: string[],
    claimIds: string[],
    employerGroups: EmployerGroups[],
    planPeriod: InitialDates,
    currentDates: CurrentDates,
    downloadfrequency: string,
    cohortDetailsList: ICohortDetails[],
    createdBy: string,
  ) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.features = features;
    this.memberIds = memberIds;
    this.claimIds = claimIds;
    this.employerGroups = employerGroups;
    this.planPeriod = planPeriod;
    this.currentDates = currentDates;
    this.downloadfrequency = downloadfrequency;
    this.cohortDetailsList = cohortDetailsList;
    this.createdBy = createdBy;
  }

  removeCustomQueriesData() {
    this.id = '';
    this.name = '';
    this.type = '';
    this.features = [];
    this.memberIds = [];
    this.claimIds = [];
    this.employerGroups = [];
    this.planPeriod = {
      start_month: '',
      end_month: '',
      plan_start_month: '',
      start_year: 0,
      end_year: 0,
      plan_end_month: '',
    recent_plan_year: 0
    };
    this.currentDates = {
      startDate: '',
      endDate: '',
    };
    this.downloadfrequency = '';
    this.cohortDetailsList = [];
    this.createdBy = '';
  }

  setCurrentDates(startDate: string, endDate: string) {
    this.currentDates = {
      startDate: startDate,
      endDate: endDate,
    };
  }

  setIsIndividualGroup(isIndividualGroup: boolean) {
    this.isIndividualGroup = isIndividualGroup;
  }
}
export default CustomQueriesStore;
